import { Country } from '@app/domain/models/country.model';

/**
 * Forma cruda de cada país tal como viene en `assets/data/countries.json`
 * (estructura derivada de la API REST Countries). Tipado explícito en lugar
 * de `any` para respetar el strict mode del proyecto.
 */
export interface CountryDto {
  name: { common: string };
  flags: { svg: string };
  idd: { root: string; suffixes?: string[] };
}

/** Transforma el DTO crudo en la entidad de dominio que consume la UI. */
export function mapCountryDtoToDomain(dto: CountryDto): Country {
  const suffix = dto.idd.suffixes?.[0] ?? '';
  return {
    name: dto.name.common,
    svg: dto.flags.svg,
    dialCode: `${dto.idd.root}${suffix}`,
  };
}
